
import React from 'react';
import { Link } from 'react-router-dom';
import logoUrl from '../assets/CF1.svg';
import fasieLogoUrl from '../assets/head_logo_fasie.png';
import fasieLogoNewUrl from '../assets/1.png';

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <div className="container">
        <div style={styles.footerContent}>
          {/* Логотип и описание */}
          <div style={styles.footerSection}>
            <div style={styles.logoWrapper}>
              <img 
                src={logoUrl} 
                alt="Сыролёт" 
                width={200}
                height={130}
                style={styles.logoImage}
              />
              <div style={styles.logoTextWrapper}>
                <h3 style={styles.footerLogo}>Сыролёт</h3>
                <p style={styles.logoSubtitle}>Российский рекомбинантный химозин</p>
              </div>
            </div>
          
          </div>

          {/* Быстрые ссылки */}
          <div style={styles.footerSection}>
            <h4 style={styles.footerHeading}>Навигация</h4>
            <ul style={styles.footerLinks}>
              <li><Link to="/" style={styles.footerLink}>Главная</Link></li>
              <li><Link to="/product" style={styles.footerLink}>Наш продукт</Link></li>
              <li><Link to="/roadmap" style={styles.footerLink}>Дорожная карта</Link></li>
              <li><Link to="/contacts" style={styles.footerLink}>Контакты</Link></li>
            </ul>
          </div>

          {/* Контакты */}
          <div style={styles.footerSection}>
            <h4 style={styles.footerHeading}>Контакты</h4>
            <ul style={styles.footerContacts}>
              <li style={styles.contactItem}>
                <span>📧</span>
                <span>syroletka@gmail.com</span>
              </li>
              <li style={styles.contactItem}>
                <span>📱</span>
                <span>+7 (996) 550-86-63</span>
              </li>
              <li style={styles.contactItem}>
                <span>📍</span>
                <span>630090, Новосибирская область, г. Новосибирск, ул. Николаева, д. 12</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Логотип ФАСИ */}
        <div style={styles.fasieLogoContainer}>
          <img 
            src={fasieLogoUrl} 
            alt="Фонд содействия инновациям" 
            style={styles.fasieLogo}
          />
        </div>

        {/* Логотип ФАСИ */}
        <div style={styles.fasieLogoContainer}>
          <img 
            src={fasieLogoNewUrl} 
            alt="Платформа университетского технологического предпринимательства" 
            style={styles.fasieLogo}
          />
        </div>

        {/* Информация о поддержке */}
        <div style={styles.supportInfo}>
          <p style={styles.supportText}>
            Проект реализован при поддержке Фонда содействия инновациям в рамках программы 
            «Студенческий стартап» мероприятия «Платформа университетского 
            технологического предпринимательства» федерального проекта «Технологии»
          </p>
        </div>

        {/* Стадия проекта */}
        <div style={styles.stageInfo}>
          <p style={styles.stageText}>
            Продукт находится на стадии опытных образцов. ТУ и декларация соответствия ЕАЭС в разработке. 
            Опытные партии передаются для испытаний и не являются товаром в обороте.
          </p>
        </div>

        {/* Копирайт */}
        <div style={styles.copyright}>
          <p>© {new Date().getFullYear()} ООО "Сыролёт". Все права защищены.</p>
        </div>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    backgroundColor: '#1E293B',
    color: 'white',
    padding: '3rem 0 1rem',
    marginTop: 'auto',
    borderTop: '1px solid rgba(255, 255, 255, 0.1)',
  },
  footerContent: {
    display: 'grid',
    gap: '3rem',
    marginBottom: '2rem',
  },
  footerSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
  logoWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    marginBottom: '0.5rem',
  },
  logoImage: {
    objectFit: 'contain',
    display: 'block',
    filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))',
  },
  logoTextWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  footerLogo: {
    fontSize: '2rem',
    fontWeight: '700',
    margin: 0,
    color: '#FFD700',
    letterSpacing: '1px',
    fontFamily: "'Advent Pro', sans-serif", // Добавлен шрифт Advent Pro
  },
  logoSubtitle: {
    color: '#94A3B8',
    fontSize: '0.875rem',
    margin: 0,
  },
  footerDescription: {
    color: '#CBD5E1',
    fontSize: '0.875rem',
    lineHeight: '1.5',
    margin: 0,
  },
  footerHeading: {
    color: 'white',
    fontSize: '1.125rem',
    marginBottom: '1rem',
  },
  footerLinks: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  footerLink: {
    color: '#CBD5E1',
    fontSize: '0.875rem',
    textDecoration: 'none',
    display: 'inline-block',
    marginBottom: '0.75rem',
    transition: 'color 0.3s ease',
  },
  footerContacts: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  contactItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '0.75rem',
    marginBottom: '0.75rem',
    color: '#CBD5E1',
    fontSize: '0.875rem',
    lineHeight: '1.4',
  },
  fasieLogoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '2rem 0',
    padding: '1rem',
  },
  fasieLogo: {
    maxWidth: '200px',
    height: 'auto',
    objectFit: 'contain',
    filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2))',
  },
  supportInfo: {
    borderTop: '1px solid rgba(255, 255, 255, 0.1)',
    padding: '1.5rem 0',
    marginBottom: '0.5rem',
  },
  supportText: {
    color: '#94A3B8',
    fontSize: '0.75rem',
    textAlign: 'center',
    lineHeight: '1.5',
    margin: 0,
  },
  stageInfo: {
    padding: '1rem 0 1.5rem',
    marginBottom: '0.5rem',
  },
  stageText: {
    color: '#94A3B8',
    fontSize: '0.75rem',
    textAlign: 'center',
    lineHeight: '1.5',
    margin: 0,
    fontStyle: 'italic',
  },
  copyright: {
    textAlign: 'center',
    color: '#6B7280',
    fontSize: '0.75rem',
    borderTop: '1px solid rgba(255, 255, 255, 0.05)',
    paddingTop: '1.5rem',
  },
};

// Добавлен media query для адаптивности
const mediaQueryStyles = `
  @media (min-width: 768px) {
    .footer-content {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  
  @media (max-width: 767px) {
    .footer-content {
      grid-template-columns: 1fr;
    }
    
    .fasie-logo {
      max-width: 150px;
    }
  }
`;

export default Footer;
